import axios from "axios";
// JWT token utilities for admin panel
export const parseJwt = (token: string) => {
  try {
    const payload = token.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(decoded)));
  } catch (err) {
    console.error('Failed to parse JWT token:', err);
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) {
    return true; // Consider invalid tokens as expired
  }

  const expiryMs = payload.exp * 1000;
  const now = Date.now();
  
  return now >= expiryMs;
};

export const getTokenExpiryTime = (token: string): number | null => {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) {
    return null;
  }
  
  return payload.exp * 1000; // Convert to milliseconds
};

export const clearAuthData = () => {
  localStorage.removeItem('adminAccessToken');
  localStorage.removeItem('adminRefreshToken');
  localStorage.removeItem('adminUser');
  
  // Clear axios default headers
  delete axios.defaults.headers.common['Authorization'];
};

export const redirectToLogin = () => {
  clearAuthData();
  window.location.href = '/login';
};

export const scheduleTokenExpiryLogout = (token: string): number | null => {
  const expiryTime = getTokenExpiryTime(token);
  if (!expiryTime) return null;

  const now = Date.now();
  const msUntilExpiry = expiryTime - now;

  if (msUntilExpiry <= 0) {
    // Token already expired
    console.warn('🚨 Admin token already expired, logging out immediately');
    redirectToLogin();
    return null;
  }

  // Set timeout to logout 1 second after expiry for safety
  const timeoutId = window.setTimeout(() => {
    console.warn('🚨 Admin token expired, auto-logging out');
    redirectToLogin();
  }, msUntilExpiry + 1000);

  console.log(`⏰ Admin token will expire in ${Math.round(msUntilExpiry / 1000)} seconds`);
  
  return timeoutId;
};